function windowLabel(appointmentWindow) {
  if (appointmentWindow === "inside") return "within the 30-day window";
  if (appointmentWindow === "outside") return "outside the 30-day window";
  return "window not yet determined";
}

export function formatAppointmentLine(appointment, formatDate) {
  return `  • ${formatDate(appointment.date)} with ${appointment.provider} (${windowLabel(appointment.window)})`;
}

const sharepointNote = (request) =>
  `Files should be placed in the SharePoint folder titled "${request.sharepointFolderName}" before the completion email goes out.`;

export const EMAIL_TEMPLATES = {
  intake_email: {
    subject: (request) => `FOIA ${request.trackingNumber} — Recording Retention Request`,
    body: (request, { appointmentLines }) =>
      `Hello,\n\n` +
      `This confirms we received the Contracting Officer's Representative request for FOIA case ${request.trackingNumber}, ` +
      `regarding the following appointment(s) for ${request.patient.name} (MRN ${request.patient.mrn}):\n\n` +
      `${appointmentLines}\n\n` +
      `We are retaining the relevant recording(s) and will follow up once the data is ready for delivery. ` +
      `${sharepointNote(request)}\n\n` +
      `Thank you,\nCortney`,
  },
  cannot_retain_email: {
    subject: (request) => `FOIA ${request.trackingNumber} — Unable to Retain Requested Recording`,
    body: (request, { appointmentLines }) =>
      `Hello,\n\n` +
      `Regarding FOIA case ${request.trackingNumber} for ${request.patient.name} (MRN ${request.patient.mrn}), ` +
      `we were unable to retain a recording for the following appointment(s) because they fall outside our 30-day retention window:\n\n` +
      `${appointmentLines}\n\n` +
      `We apologize for the inconvenience and are closing this request on our end. Please let us know if you have any questions.\n\n` +
      `Thank you,\nCortney`,
  },
  completion_email: {
    subject: (request) => `FOIA ${request.trackingNumber} — Recording Delivered`,
    body: (request, { appointmentLines }) =>
      `Hello,\n\n` +
      `The requested recording(s) for FOIA case ${request.trackingNumber} (${request.patient.name}, MRN ${request.patient.mrn}) ` +
      `have been uploaded to the SharePoint folder titled "${request.sharepointFolderName}":\n\n` +
      `${appointmentLines}\n\n` +
      `Please confirm receipt at your convenience.\n\n` +
      `Thank you,\nCortney`,
  },
  deletion_email: {
    subject: (request) => `FOIA ${request.trackingNumber} — Data Deletion Confirmed`,
    body: (request) =>
      `Hello,\n\n` +
      `As requested, the data associated with FOIA case ${request.trackingNumber} (${request.patient.name}, MRN ${request.patient.mrn}) ` +
      `has been deleted. Please let us know if you have any questions.\n\n` +
      `Thank you,\nCortney`,
  },
};
